// Extract the human failure reason from a SuperFetch response, regardless of which
// App Server error path produced it:
//   - the `responder` middleware coerces the reason to a STRING in `error` (String(data.error))
//   - `errorResponder` sends a raw Error OBJECT in `error` (so the reason is `error.message`)
//   - many routes put the actionable reason in `info` (next({ code, info })) while `message`
//     stays the generic HTTP reason ('Bad Request'/'Forbidden') — so `info` must win over `message`
//   - some legacy routes put it in `data[0].errmsg` / `data[0].msg`
//
// Reading `.message` off the string shape (the common case) silently yields undefined,
// which is why call sites kept falling through to a generic "An error occurred". Handle
// every shape and return the trimmed reason, or '' when there's nothing usable.
// (On the error path `info` holds the reason; routes that don't set it fall through to `message`
// unchanged, so this is backward-compatible for every existing caller.)
export const getApiError = (res) => {
	const err = res?.error;
	const fromError = typeof err === 'string' ? err : err?.message;
	const legacy = Array.isArray(res?.data) ? res.data[0]?.errmsg || res.data[0]?.msg : undefined;
	return (fromError ?? legacy ?? res?.info ?? res?.message ?? '').toString().trim();
};
